import EmailNotificationBaseService from 'services/notification/subServices/email/EmailNotificationBaseService';

import RegistrationEmailNotification from 'models/notification/email/RegistrationEmailNotification';

export default class RegistrationEmailNotificationService extends EmailNotificationBaseService {
	toModel(notification) {
		return new RegistrationEmailNotification(notification);
	}
}
